import { Dialog, DialogProps, useMediaQuery, useTheme } from '@mui/material';
import styles from './BaseModal.module.scss';

export function BaseModal(props: DialogProps) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            {...props}
            fullScreen={fullScreen}
            maxWidth={props.maxWidth ?? 'md'}
            fullWidth={props.fullWidth ?? true}
            className={`${!fullScreen ? styles.modal : ''} ${props.className}`}
        >
            {props.children}
        </Dialog>
    );
}
